import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { base_url } from '../global';
import { Observable, of, throwError } from 'rxjs';
import { catchError, finalize, map, switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class FinancialsService {
constructor(private http: HttpClient) {}
  addFinYear(data: any) {
    let api_url = base_url + 'add-financial-year';
    const httpOptions = {
      headers: new HttpHeaders({
        'content-type': 'application/json;charset=UTF-8',
      }),
    };
    return this.http.post(api_url, data, httpOptions);
  }
  getFinYears() {
    let api_url = base_url + 'get-financial-year';
    const httpOptions = {
      headers: new HttpHeaders({
        'content-type': 'application/json;charset=UTF-8',
      }),
    };
    return this.http.get(api_url, httpOptions);
  }
  updateFinYear(data: any, id: string) {
    let api_url = base_url + 'update-financial-year' + '/' + id;
    const httpOptions = {
      headers: new HttpHeaders({
        'content-type': 'application/json;charset=UTF-8',
      }),
    };
    return this.http.put(api_url, data, httpOptions);
  }
  toggleFinYear(data: any, id: string) {
    let api_url = base_url + 'toggle-financial-year' + '/' + id;
    const httpOptions = {
      headers: new HttpHeaders({
        'content-type': 'application/json;charset=UTF-8',
      }),
    };
    return this.http.put(api_url, data, httpOptions);
  }
  makeDefFinYear(data: any, id: string) {
    let api_url = base_url + 'default-financial-year' + '/' + id;
    const httpOptions = {
      headers: new HttpHeaders({
        'content-type': 'application/json;charset=UTF-8',
      }),
    };
    return this.http.put(api_url, data, httpOptions);
  }
  getCookie(data: any, name: string) {
    let api_url = base_url + 'get-cookie' + '/' + name;
    const httpOptions = {
      headers: new HttpHeaders({
        'content-type': 'application/json;charset=UTF-8',
      }),
    };
    return this.http.post(api_url, data, httpOptions);
  }

  setCookie(data: any, name: string) {
    let api_url = base_url + 'set-cookie' + '/' + name;
    const httpOptions = {
      headers: new HttpHeaders({
        'content-type': 'application/json;charset=UTF-8',
      }),
    };
    return this.http.post(api_url, data, httpOptions);
  }
  updateWinFinYear(data: any, id: string) {
    let api_url = base_url + 'financial-year' + '/' + id;
    const httpOptions = {
      headers: new HttpHeaders({
        'content-type': 'application/json;charset=UTF-8',
      }),
    };
    return this.http.put(api_url, data, httpOptions);
  }
  getFinancialId(email: any) {
    let api_url = base_url + 'financial-year-id' + '/' + email;
    const httpOptions = {
      headers: new HttpHeaders({
        'content-type': 'application/json;charset=UTF-8',
      }),
    };
    return this.http.get(api_url, httpOptions);
  }

  finYears:any[]=[];
  getFinYear(): Observable<string> {
  return this.getFinYears().pipe( // Step 1: fetch financial years
    switchMap((resp: any) => {
      this.finYears = resp.data; // store the data

      return this.getCookie({}, 'financialYear').pipe( // Step 2: fetch cookie
        map((cookieResp: any) => {
          const cookieYear = cookieResp?.cookie;
          const matched = this.finYears.find(fy => fy._id == cookieYear);
          if (matched) {
            return matched.financialYear;
          } else {
            console.warn(`No matching _id found for cookie value: ${cookieYear}`);
            return '';
          }
        }),
        catchError(() => {
          window.alert('Error getting financial year cookie');
          return of('');
        })
      );
    }),
    catchError(() => {
      window.alert('Error loading financial years');
      return of('');
    })
  );
}

 post(endpoint: string, data: any): Observable<any> {
    return this.handleApiCall(this.http.post(`${base_url}${endpoint}`, data));
  }

handleApiCall(apiCall$: Observable<any>): Observable<any> {
  return apiCall$.pipe(
    catchError((error: HttpErrorResponse) => {
      // Log error or do minimal handling
      console.error('API Error:', error);
      return throwError(() => error);
    })
  );
}
}
